


































































































































































































import moment from 'moment';
import { Vue, Component } from 'vue-property-decorator';
import { VbPagination } from '@/shared/pagination/pagination.component.vue';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import DateHandler from '@/shared/utils/date-format';
import toDocument from '@/shared/directive/toDocument';
import EventBus, { Event } from '@/event.bus'
import UserBusinessUnitService from '@/domain/business-unit/service/business-unit.store';
import ContractGroupService from '@/domain/contract/service/contract-group.service';
import AuthorityService from '@/domain/security/authority.service';
import BusinessUnit from '@/domain/business-unit/entity/business-unit.entity';
import ContractList from '@/domain/contract/entity/contract-list.entity';
import ContractGroup from '@/domain/contract/entity/contract-group.entity';
import ContractGroupFilter from '@/domain/contract/entity/contract-group-filter.entity';
import ContractGroupFilterBind from '@/domain/contract/entity/contract-group-filter-bind.entity';
import Pagination from '@/domain/pagination.entity';
import Response from '@/domain/response.entity';
import ModalWarning from '@/shared/modal/modal-warning.component.vue';
import Header from './header.json';
import ContractGroupFilterComponent from './contract-group-filter.component.vue';
import CreateContractGroupModal from '../contract/contract-info/contract-group-connect-modal.component.vue';
import EditContractGroupModal from './contract-group-edit-modal.component.vue';
import ContractModal from './contract-group-contracts-modal.component.vue';
import ContractBindModal from './contract-group-bind-modal.component.vue';

@Component({
  components: {
    ContractGroupFilterComponent,
    VbTooltipSlot,
    VbPagination,
    CreateContractGroupModal,
    EditContractGroupModal,
    ContractModal,
    ModalWarning,
    ContractBindModal,
  },
  filters: {
    formatDate(value: string) {
      return DateHandler.timestampToLocal(moment(value).format('YYYY-MM-DD'));
    },
    toDocument(value: string) {
      return toDocument(value);
    },
  },
})
export default class ContractGroupDataTable extends Vue {
  hasAdministratorAuthority: boolean = false;

  businessUnitId: string = '';

  header = Header;

  contractGroups: ContractGroup[] = [];

  loading: boolean = false;

  loadingBindModal: boolean = false;

  showFilter: boolean = false;

  filter: ContractGroupFilter = ContractGroupFilter.of({});

  filterContractBindModal: ContractGroupFilterBind = ContractGroupFilterBind.of({});

  showCreateModal: boolean = false;

  showEditModal: boolean = false;

  showContractModal: boolean = false;

  showContractBindModal: boolean = false;

  warningModal: boolean = false;

  warningMessage: string = '';

  deleteGroupId: string = '';

  contracts: ContractList[] = [];

  contractsBindModal: ContractList[] = [];

  contractGroupSelected: ContractGroup = ContractGroup.of({});

  selectedAllContracts: boolean = false;

  pagination: Pagination = new Pagination({
    page: 0,
    itemsPerPage: 10,
    sortBy: [],
    defaultSort: 'createdDate|desc',
  });

  paginationContractBindModal: Pagination = new Pagination({
    page: 0,
    itemsPerPage: 10,
    sortBy: [],
    defaultSort: 'externalId|desc',
  });

  get menuIcon(): string {
    return this.showFilter ? 'mdi-filter' : 'mdi-filter-outline'
  }

  toolTipModalContracts(contractGroup: ContractGroup) {
    if (contractGroup.hasContract) {
      return 'Contratos vinculados';
    }
    return 'Nenhum contrato vinculado';
  }

  toolTipDelete(contractGroup: ContractGroup) {
    if (contractGroup.hasContract) {
      return 'Grupo com contratos vinculados, não é possível excluir';
    }
    return 'Excluir';
  }

  created() {
    this.validateAuthority();
    this.businessUnitId = UserBusinessUnitService.currentBusinessUnit.id;
    if (this.businessUnitId) {
      EventBus.$off(Event.BUSINESS_UNIT_SELECTED);
    }
    EventBus.$on(Event.BUSINESS_UNIT_SELECTED, (businessUnit: BusinessUnit) => {
      if (this.$route.name && (this.$route.name.includes('Grupos de contratos') || this.$route.name.includes('ContractGroupDataTable'))) {
        this.businessUnitId = businessUnit.id;
        this.pagination.page = 1
        this.findContractGroups(this.filter);
      }
    });
    this.findContractGroups(this.filter);
  }

  validateAuthority(): void {
    AuthorityService.authorities().then((response) => {
      if (response.includes('ADMINISTRATOR')) {
        this.hasAdministratorAuthority = true;
      }
    });
  }

  findContractGroups(filter: ContractGroupFilter) {
    if (this.businessUnitId) {
      this.loading = true;
      ContractGroupService.filter(this.pagination, this.businessUnitId, filter)
        .then((response: Response) => {
          this.contractGroups = ContractGroup.ofList(response.content);
          this.pagination.pageCount = response.totalPages
          this.pagination.total = response.totalElements;
        })
        .catch((err: any) => VbSnackbarService.handleHttpError(err))
        .finally(() => {
          this.loading = false;
        });
    }
  }

  applyFilter(filter: ContractGroupFilter) {
    this.filter = filter;
    this.pagination.page = 1;
    this.findContractGroups(this.filter);
  }

  applyFilterBind(filter: ContractGroupFilterBind) {
    this.filterContractBindModal = filter;
    this.pagination.page = 1;
    this.findContract(this.filterContractBindModal);
  }

  updateTable(pagination: Pagination) {
    this.pagination.verifyPage();
    this.findContractGroups(this.filter);
  }

  updateTableBindModal(pagination: Pagination) {
    this.pagination.verifyPage();
    this.findContract(this.filterContractBindModal);
  }

  handleModalContractGroup() {
    this.showCreateModal = true;
  }

  refreshContractGroup() {
    this.showCreateModal = false;
    this.showEditModal = false;
    this.findContractGroups(this.filter);
  }

  handleModalEdit(contractGroup: ContractGroup) {
    this.contractGroupSelected = contractGroup;
    this.showEditModal = true;
  }

  handleModalContracts(contractGroup: ContractGroup) {
    this.contractGroupSelected = contractGroup;
    this.getContracts();
    this.showContractModal = true;
  }

  handleModalBindContracts(contractGroup: ContractGroup) {
    this.findContract(this.filterContractBindModal);
    this.contractGroupSelected = contractGroup;
    this.showContractBindModal = true;
  }

  cancelModalEdit() {
    this.showEditModal = false;
    this.findContractGroups(this.filter);
  }

  cancelModalContractBind() {
    this.showContractBindModal = false;
    this.filterContractBindModal = ContractGroupFilterBind.of({});
  }

  cancelModalContract() {
    this.showContractModal = false;
    this.selectedAllContracts = false;
  }

  async getContracts() {
    ContractGroupService.getContractsFromContractGroup(this.contractGroupSelected.id)
      .then((response: any) => {
        this.contracts = ContractList.ofList(response);
      })
      .catch(() => VbSnackbarService.showError('Erro ao buscar os contratos do Grupo de Contrato!'))
  }

  openWarningModal(id: string) {
    this.deleteGroupId = id;
    this.warningModal = true;
    this.warningMessage = 'Deseja realmente <strong style="color: orange">remover</strong> o grupo de contratos? '
    + 'Ao clicar no botão Sim, as alterações serão imediatamente realizadas.';
  }

  deleteContractGroup(id: string) {
    ContractGroupService.deleteContractGroup(id)
      .then(() => {
        VbSnackbarService.showSuccess('Grupo de Contrato excluído com sucesso!');
        this.findContractGroups(this.filter);
      })
      .catch((err: any) => VbSnackbarService.handleHttpError(err))
      .finally(() => {
        this.warningModal = false;
        this.deleteGroupId = '';
      });
  }

  unbindAllSelectedContracts(contractsIds: string[]) {
    ContractGroupService.bindOrUnbindContractGroup(contractsIds)
      .then(() => {
        VbSnackbarService.showSuccess('Contratos desvinculados com sucesso!');
      })
      .catch((err: any) => VbSnackbarService.handleHttpError(err))
      .finally(() => {
        this.findContractGroups(this.filter);
      });
  }

  bindAllSelectedContracts(contractsIds: string[]) {
    ContractGroupService.bindOrUnbindContractGroup(contractsIds, this.contractGroupSelected.id)
      .then(() => {
        VbSnackbarService.showSuccess('Contratos vinculados com sucesso!');
      })
      .catch((err: any) => VbSnackbarService.handleHttpError(err))
      .finally(() => {
        this.findContractGroups(this.filter);
        this.selectedAllContracts = false;
      });
  }

  findContract(filter: ContractGroupFilterBind) {
    this.loading = true;
    ContractGroupService.filterContractsToBind(this.paginationContractBindModal,
      this.businessUnitId, filter)
      .then((response: Response) => {
        this.contractsBindModal = ContractList.ofList(response.content);
        this.paginationContractBindModal.pageCount = response.totalPages
        this.paginationContractBindModal.total = response.totalElements;
      })
      .catch((err: any) => VbSnackbarService.handleHttpError(err))
      .finally(() => {
        this.loading = false;
      });
  }
}
